import { clearStoredAuthEmail, getStoredAuthEmail, initConnectCta } from './connectCta'

const API_URL = 'https://api.payhook.link'
const STORAGE_KEY = 'payhook:accountId'
const ACCOUNT_LABEL_KEY = 'payhook:accountLabel'

export function getStoredAccountId () {
  return window.localStorage.getItem(STORAGE_KEY)
}

export function clearStoredAccountId () {
  window.localStorage.removeItem(STORAGE_KEY)
  window.localStorage.removeItem(ACCOUNT_LABEL_KEY)
  clearStoredAuthEmail()
  window.fetch(`${API_URL}/auth/signout`, {
    method: 'POST',
    credentials: 'include'
  }).catch(() => {})
}

function setConnectVisible (visible) {
  document.querySelectorAll('[data-connect-cta]').forEach((el) => {
    if (el.id === 'hero-primary-cta') return
    el.hidden = !visible
  })
}

function updateHeroPrimaryCta (isConnected) {
  const heroCta = document.getElementById('hero-primary-cta')
  if (!heroCta) return

  heroCta.hidden = false
  heroCta.textContent = isConnected ? 'Open Dashboard' : 'Start setup'
}

export function updateSiteHeader () {
  const dashboardBtn = document.getElementById('header-dashboard-btn')
  const disconnectBtn = document.getElementById('header-disconnect-btn')
  const isConnected = Boolean(getStoredAccountId() || getStoredAuthEmail())

  setConnectVisible(!isConnected)
  updateHeroPrimaryCta(isConnected)

  if (dashboardBtn) dashboardBtn.hidden = !isConnected
  if (disconnectBtn) disconnectBtn.hidden = !isConnected
}

function closeMobileMenu () {
  const header = document.querySelector('.site-header')
  const toggle = document.getElementById('header-menu-toggle')
  if (!header || !toggle) return

  header.classList.remove('is-open')
  toggle.setAttribute('aria-expanded', 'false')
  toggle.setAttribute('aria-label', 'Open menu')
}

function initMobileMenu () {
  const toggle = document.getElementById('header-menu-toggle')
  const header = document.querySelector('.site-header')
  const panel = document.getElementById('site-header-nav')
  if (!toggle || !header || !panel) return

  toggle.addEventListener('click', () => {
    const open = header.classList.toggle('is-open')
    toggle.setAttribute('aria-expanded', String(open))
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu')
  })

  panel.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', closeMobileMenu)
  })

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileMenu()
  })

  document.addEventListener('click', (event) => {
    if (!header.contains(event.target)) closeMobileMenu()
  })
}

function initHeaderDisconnectButton () {
  const headerDisconnectBtn = document.getElementById('header-disconnect-btn')
  if (headerDisconnectBtn) {
    headerDisconnectBtn.addEventListener('click', () => {
      clearStoredAccountId()
      updateSiteHeader()
    })
  }
}

export function initSiteHeader () {
  updateSiteHeader()
  initMobileMenu()
  initConnectCta()
  initHeaderDisconnectButton()
}
